const { BASE_URL } = require("./client");

const POST_FORM = BASE_URL + "/api/form/post";

module.exports = {
  POST_FORM,
};
